module.exports = __webpack_public_path__ + "img/t4-12.9dc7e3ad.svg";